export default [
  // {
  //   title: 'Home',
  //   route: 'home',
  //   icon: 'HomeIcon',
  // },
  {
    title: 'Sims',
    route: 'sims',
    icon: 'SmartphoneIcon',
  },
  {
    title: 'Batches',
    route: 'batches',
    icon: 'TruckIcon',
  },
  {
    title: 'Sim Swaps',
    route: 'sim-swap-list',
    icon: 'CodeIcon',
  },
  {
    title: '3G Sunset',
    route: 'sunset-dash',
    icon: 'SunsetIcon'
  },
  {
    title: 'Map',
    route: 'map-dash',
    icon: 'MapIcon'
  }
]
